import React, { useState, useEffect } from 'react'
import CustomSelect from './CustomSelect';


export default function SelectWithCustomValue(props) {

    const [option, setOption] = useState(props.options);
    const {children, ...restProps} = props;

    useEffect(() => {
        setOption(props.options);
      }, [props.options])

    const onSearch = (input) =>{
      let found = false;
      (option.forEach((o)=> {
        if(o.label.includes(input))
          found = true
        }))
      if(!found){
        setOption([...props.options,{label:input,value:input}])
      }
    }

        return (
            <CustomSelect
                {...restProps}
                mode="version"
                allowClear
                style={{ width: '100%' }}
                options={option}
                onSearch={onSearch}
                showSearch
                filterOption
            />
        )
    }
